import { useEffect, useMemo } from 'react';
import { useDashboardPresets } from '@/entities/settings';
import type { ChartTableViewStore } from '../ui/DashboardPresetGrid/ChartTableViewContext';

/**
 * Запись вида колонок таблиц применённого дашборда — по правилам его фильтров: у того, кто дашборд
 * правит (кроме автора системного), — в сам дашборд, у прочих — за смотрящим поверх вида дашборда.
 *
 * С открытием дашборда его владелец получает видом колонок дашборда настройку колонок, которую
 * прежний клиент запоминал за ним лично, — у таблиц, вида колонок в дашборде ещё не имеющих.
 */
export const useAppliedChartTableViews = (presetId: string): ChartTableViewStore => {
  const { isActiveChangeOwn, readOwnTableView, setActiveTableView, clearActiveTableView, adoptLegacyTableViews } =
    useDashboardPresets();

  // Перенос — однажды на открытие дашборда: перенесённая настройка снимается, и повторять его нечем
  // biome-ignore lint/correctness/useExhaustiveDependencies: перенос привязан к открытию дашборда, а не к каждой правке состава
  useEffect(() => {
    void adoptLegacyTableViews();
  }, [presetId]);

  return useMemo(
    () => ({
      readOwnView: readOwnTableView,
      clearsToDashboardView: isActiveChangeOwn,
      onChange: (chartId, view) => void setActiveTableView(chartId, view),
      onClear: (chartId) => void clearActiveTableView(chartId),
    }),
    [readOwnTableView, isActiveChangeOwn, setActiveTableView, clearActiveTableView],
  );
};
